/** Dropdown value when the user clears the primary Dx selection. */
export const NONE_OF_THE_ABOVE_OPTION = "none_of_the_above";

/** Dropdown value when the user enters a Dx code manually. */
export const ENTER_MANUALLY_OPTION = "enter_manually";
